import Vue from 'vue'
import VueRouter from 'vue-router';
Vue.use(VueRouter);

import firebase from 'firebase';

import loginPage from './components/pages/login'
import dashboard from './components/pages/dashboard'

import notFound from './components/notFound.vue'
import Forbidden from './components/Forbidden.vue'

const routes = [
	{
		path: '/login',
		name:'login',
		component: loginPage,
	},{
		path: '/',
		name:'dashboard',
		component: dashboard,
		meta:{
			requiresAuth:true,
		}
	},{
		path: '/404',
		name: '404',
		component: notFound,
	},{
		path: '/403',
		name: '403',
		component: Forbidden,
	},{
		path: '*',
		redirect: '/404'
	}
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes : routes
})



router.beforeEach((to, from, next) => {
	const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
	const requiresAdminClaims = to.matched.some(record => record.meta.requiresAdminClaims);
	const currentUser = firebase.auth().currentUser;

	if(currentUser){
		firebase.auth().currentUser.getIdTokenResult().then((idTokenResult)=>{
			if (requiresAdminClaims && !idTokenResult.claims.isAdmin) next('403');
			else next();
		});
	}else{
		if(requiresAuth || requiresAdminClaims) next('login');
		else next();
	}
});

export default router;